import { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Grid,
  TablePagination
} from "@mui/material";
import BASE_URL from "../config";
const FeeBalanceSMS = () => {
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [studentss, setStudentss] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  
  useEffect(() => {
    fetchCourses();
  }, []);
  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/coursesa`);
      setCourses(res.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  const fetchAcademicYears = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/academicYears/${courseID}`);
      setAcademicYears(res.data);
    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };
  const fetchClasses = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseID}`);
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const handleCourseChange = (courseID) => {
    setSelectedCourse(courseID);
    setSelectedYear("");
    setSelectedClass("");
    if (courseID) {
      fetchAcademicYears(courseID);
      fetchClasses(courseID);
    } else {
      setAcademicYears([]);
      setClasses([]);
    }
  };
    useEffect(() => {
       //try {
      const params = {};
      if (selectedCourse) params.courseID = selectedCourse;
      if (selectedYear) params.academicYear = selectedYear;
      if (selectedClass) params.classID = selectedClass;
      if (searchName) params.studentName = searchName;
    axios.get(`${BASE_URL}/api/feebalance`,{params})
      .then(res => setStudentss(res.data))
      .catch(err => alert('Failed to fetch students'));
  }, [selectedCourse, selectedYear, selectedClass, searchName]);
  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedIDs(!selectAll ? studentss.map(s => s.StudentID) : []);
  };
  const toggleSelect = (id) => {
    setSelectedIDs(prev =>
      prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]
    );
  };
  const sendSMS = () => {
    if (selectedIDs.length === 0) {
      alert('Select at least one student');
      return;
    }
    const selectedStudents = studentss.filter(s => selectedIDs.includes(s.StudentID));
    axios.post(`${BASE_URL}/api/sendfeesms`, { selectedStudents })
      .then(() => alert('SMS sent successfully'))
      .catch(() => alert('Error sending SMS'));
  };
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Manage Students
        </Typography>
        {/* Filters */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Course"
              value={selectedCourse || ""}
              onChange={(e) => handleCourseChange(e.target.value)}
            >
              <MenuItem value="">-- Select Course --</MenuItem>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <MenuItem key={course.CourseID} value={course.CourseID}>
                    {course.CourseName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No courses available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Academic Year"
              value={selectedYear || ""}
              onChange={(e) => setSelectedYear(e.target.value)}
              disabled={!selectedCourse || academicYears.length === 0}
            >
              <MenuItem value="">-- Select Academic Year --</MenuItem>
              {academicYears.length > 0 ? (
                academicYears.map((year) => (
                  <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                    {year.AcademicYearName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No academic years available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Class"
              value={selectedClass || ""}
              onChange={(e) => setSelectedClass(e.target.value)}
              disabled={!selectedCourse || classes.length === 0}
            >
              <MenuItem value="">-- Select Class --</MenuItem>
              {classes.length > 0 ? (
                classes.map((cls) => (
                  <MenuItem key={cls.id || cls.ClassID} value={cls.id || cls.ClassID}>
                    {cls.name || cls.ClassName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No classes available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Search Student Name/ID"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={sendSMS}>Send SMS
            
            </Button>
          </Grid>
          
        </Grid>
          </Card>
              {/* Students Table */}
        <TableContainer component={Paper} sx={{ mt: 4 }}>
  <Table>
    <TableHead sx={{ backgroundColor: "#1976D2" }}>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            checked={selectAll}
            onChange={toggleSelectAll}
          />
        </TableCell>
        <TableCell sx={{ color: "white" }}>Student Name</TableCell>
        <TableCell sx={{ color: "white" }}>Mobile Number</TableCell>
        <TableCell sx={{ color: "white" }}>Parent Contact</TableCell>
        <TableCell sx={{ color: "white" }}>Total Fee</TableCell>
        <TableCell sx={{ color: "white" }}>Paid Fee</TableCell>
        <TableCell sx={{ color: "white" }}>Balance</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {studentss.length > 0 ? (
        studentss
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((student) => (
            <TableRow key={student.StudentID}>
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  checked={selectedIDs.includes(student.StudentID)}
                  onChange={() => toggleSelect(student.StudentID)}
                />
              </TableCell>
              <TableCell>{student.StudentName}</TableCell>
              <TableCell>{student.MobileNumber}</TableCell>
              <TableCell>{student.ParentContact || 'N/A'}</TableCell>
              <TableCell>{student.Fees}</TableCell>
              <TableCell>{student.PaidFee}</TableCell>
              <TableCell>{student.BalanceFee}</TableCell>
            </TableRow>
          ))
      ) : (
        <TableRow>
          <TableCell colSpan={7} align="center">
            No students found.
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
  <TablePagination
    rowsPerPageOptions={[5, 10, 25]}
    component="div"
    count={studentss.length}
    rowsPerPage={rowsPerPage}
    page={page}
    onPageChange={(event, newPage) => setPage(newPage)}
    onRowsPerPageChange={(event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    }}
  />
</TableContainer>
</Container>           
  );
};
export default FeeBalanceSMS;
